import http from '@/requests/http'
import appConfig from '@/config/app'

class Callback {
  static all (params) {
    return http.post('callback/index', params)
  }
  static async update (data) {
    return http.post('callback/update', data)
  }
  static async viewCaller (params) {
    return http.post('callback/caller/view', params)
  }
  static async view (params) {
    return http.post('callback/view', params)
  }
  static async save (data) {
    return http.post('callback/store', data)
  }
  static async delete (id) {
    return http.post(`callback/delete/${id}`)
  }
  static async export (params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl  }/callback/export?${URLparams}`, '_blank')
  }
  static async getCallbackCount () {
    return http.post('callback/count')
  }
  static async updateTreatmentResult (data) {
    return http.post('callback/treatment-result/update', data)
  }
}

export default Callback
